/**
 * Add target="_blank" to all external links on the page
 */
export const handleExternalLinks = (): void => {
  // Get all <a> tags on the page
  const links = document.querySelectorAll('a');

  // Get the base domain of the current site
  const currentDomain = window.location.hostname;

  // Extract the base domain
  const getBaseDomain = (hostname: string): string => {
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      // Take the last two parts of the domain
      return parts.slice(-2).join('.');
    }
    return hostname;
  };

  const siteBaseDomain = getBaseDomain(currentDomain);

  // Loop through all links
  links.forEach((link) => {
    const href = link.getAttribute('href');

    // Skip if no href or if target is already set
    if (!href || link.hasAttribute('target')) {
      return;
    }

    try {
      // Check if it's an external link (starts with http or https)
      if (href.match(/^https?:\/\//i)) {
        const url = new URL(href);
        const linkBaseDomain = getBaseDomain(url.hostname);

        // If domains don't match, it's external
        if (linkBaseDomain !== siteBaseDomain) {
          link.setAttribute('target', '_blank');
          // For security best practices, add rel attributes
          link.setAttribute('rel', 'noopener noreferrer');
        }
      }
    } catch (error) {
      // If URL parsing fails, skip this link
      console.log({ error: `Error processing link: ${href}` });
    }
  });
};
